import { render, staticRenderFns } from "./MDTindakan.vue?vue&type=template&id=79623edf&scoped=true&"
import script from "./MDTindakan.vue?vue&type=script&lang=js&"
export * from "./MDTindakan.vue?vue&type=script&lang=js&"
import style0 from "./MDTindakan.vue?vue&type=style&index=0&id=79623edf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79623edf",
  null
  
)

export default component.exports